import { mergeStyleSets, getTheme } from "@fluentui/react";

const theme = getTheme();

// Animation logic for shared use across components
let animationKeyframesInjected = false;

export const injectAnimationKeyframes = () => {
  if (animationKeyframesInjected || typeof document === "undefined") return;

  const styleSheet = document.createElement("style");
  styleSheet.type = "text/css";
  styleSheet.innerText = `
    @keyframes wiggle {
      0% { transform: translateX(0); }
      15% { transform: translateX(-6px); }
      30% { transform: translateX(6px); }
      45% { transform: translateX(-6px); }
      60% { transform: translateX(6px); }
      75% { transform: translateX(-4px); }
      100% { transform: translateX(0); }
    }
    
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
  `;
  document.head.appendChild(styleSheet);
  animationKeyframesInjected = true;
};

// Auto-inject keyframes when this module is imported
injectAnimationKeyframes();

// Style object for wiggle animation
export const injectWiggleAnimation = {
  animation: "wiggle 0.6s",
};

const styles = mergeStyleSets({
  pageStyles: {
    padding: "20px",
    height: "100%",
    width: "100%",
    display: "flex",
    overflow: "hidden",
  },
  loadingSpinner: {
    alignItems: "center",
    display: "flex",
    height: "100%",
    justifyContent: "center",
  },
  tableNotSet: {
    fontStyle: "italic",
    color: theme.palette.neutralSecondaryAlt,
  },
  noTableItems: {
    color: theme.palette.neutralSecondaryAlt,
    fontStyle: "italic",
    margin: "10px",
    padding: "10px",
    textAlign: "center",
    backgroundColor: theme.palette.neutralLighterAlt,
    borderRadius: "4px",
  },
  // Goes around the DetailsList to apply sticky header
  detailsListWrapperWithStickyHeader: {
    position: "relative",
    height: "100%",
    minHeight: "0",
  },
  // DetailsList styling with sticky headers and scrolling
  detailslistRoot: {
    background: theme.palette.white,
    overflowX: "hidden",
    height: "100%",
    "& .ms-DetailsList-contentWrapper": {
      overflow: "auto",
      scrollbarWidth: "thin",
    },
    "& .ms-DetailsList-headerWrapper": {
      position: "sticky !important" as any,
      top: "0 !important" as any,
      zIndex: "10 !important" as any,
      backgroundColor: `${theme.palette.white} !important` as any,
      borderBottom: `1px solid ${theme.palette.neutralLight} !important` as any,
    },
    "& .ms-DetailsHeader": {
      position: "sticky !important" as any,
      top: "0 !important" as any,
      zIndex: "10 !important" as any,
      backgroundColor: `${theme.palette.white} !important` as any,
      borderBottom: `1px solid ${theme.palette.neutralLight} !important` as any,
    },
  },
  dotCellRendererContainer: {
    display: "flex",
    alignItems: "center",
    gap: 8,
  },
  dotCellRendererDot: {
    width: 8,
    height: 8,
    borderRadius: "50%",
  },
  dotCellRendererText: {
    fontSize: "14px",
    fontWeight: "500",
  },
  multiStatusCell: {
    display: "flex",
    flexWrap: "wrap",
    gap: 4,
  },
  multiStatusCellStatus: {
    borderRadius: "4px",
    padding: "2px 4px",
  },
  colorUnknown: {
    color: theme.palette.neutralSecondaryAlt,
  },
  spinnerOverlay: {
    position: "absolute" as const,
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: `${theme.palette.white}B3`, // 70% opacity
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
    flexDirection: "column" as const,
    borderRadius: "8px",
  },
  statusIcon: {
    fontSize: 15,
  },
  statusIconSpinning: {
    fontSize: 15,
    animation: "spin 4s linear infinite",
  },
  statusIconPageRight: {
    fontSize: 18,
  },
  panelHeader: {
    width: "100%",
  },
  panelHeaderLabel: {
    paddingLeft: "12px",
  },
  link: {
    color: theme.palette.themePrimary,
  },
  // helper for overflow containers
  flexOverflowContainer: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    minHeight: 0,
  },
  scrollbarThin: {
    overflowY: "auto",
    scrollbarWidth: "thin",
    scrollbarColor: `${theme.palette.neutralTertiary} ${theme.palette.neutralLighterAlt}`,
  },
});

export { styles };
